import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import aggregated locale files
import en from "../locales/en";
//import de from "../locales/de";

//import it from "../locales/it";
import es from "../locales/es";
//import ar from "../locales/ar";

// Initialize i18n
i18n
    .use(initReactI18next)
    .init({
        resources: {
            en,
            // de,
            // it,
            es,
            // ar
        },
        lng: "en", // Default language
        fallbackLng: "en", // Fallback language
        interpolation: { escapeValue: false }, // React already safeguards against XSS
    });

export default i18n;

